<template>
	<div>
		<TilteParallax>
			<template v-slot:title>
				Clientes
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="default"
							fab
							v-bind="attrs"
							v-on="on"
							elevation="5"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item @click="customerCreate()">
							<v-list-item-title>
								Nuevo
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>

			<template v-slot:subtitle>
				{{ `Clientes: ${customers.length}` }}
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center" class="pt-0 mt-0">
				<v-col cols="12" md="10">
					<v-card outlined :loading="ui.geting">
						<v-card-text>
							<v-row>
								<v-col cols="12">
									<v-text-field
										dense
										outlined
										clearable
										hide-details
										label="Cíterio de busqueda"
										v-model="criterium"
									></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-data-table
										:search="criterium"
										:headers="headers"
										:items="customers"
									>
										<!-- Price List Slot -->
										<template
											v-slot:item.price_list="{ item }"
										>
											<router-link
												v-if="item.price_list"
												:to="{
													name: 'PriceListShow',
													params: {
														id: item.price_list.id,
													},
												}"
											>
												{{ item.price_list.name }}
											</router-link>
										</template>

										<!-- Slot Actions -->
										<template
											v-slot:item.actions="{ item }"
										>
											<router-link
												class="font-weight-bold"
												:to="{
													name: 'CustomerShow',
													params: { id: item.id },
												}"
											>
												Ver
											</router-link>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- CustomerCreate Component -->
		<CustomerCreate />
	</div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/main";
import TilteParallax from "@/components/TilteParallax";
import { mapState } from "vuex";
import CustomerCreate from "@/components/Customer/Create";

export default {
	components: { TilteParallax, CustomerCreate },

	data() {
		return {
			headers: [
				{ text: "Folio", value: "folio" },
				{ text: "Nombre", value: "name" },
				{ text: "RFC", value: "rfc" },
				{ text: "Usuario", value: "user.email" },
				{ text: "Lista de precios", value: "price_list" },
				{ text: "Acciones", value: "actions" },
			],

			customers: [],

			criterium: null,

			ui: {
				geting: true,
			},
		};
	},

	created() {
		this.get();

		EventBus.$on("CustomerCreated", (customer) => {
			this.customers.push(customer);
		});
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;
				let response = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/store/customer`,
					{
						headers: {
							Authorization: `Bearer ${this.acount.token}`,
						},
					}
				);

				this.customers = response.data.data;
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.geting = false;
			}
		},

		customerCreate() {
			EventBus.$emit("CustomerCreate");
		},
	},

	computed: {
		...mapState(["acount"]),
	},
};
</script>

<style lang="css" scoped></style>
